<template>
    <v-dialog v-model="dialog" max-width="800">
        <v-card>
            <v-card-title class="d-flex justify-space-between align-center">
                <slot name="title" class="font-weight-medium"></slot>
                <v-icon-btn
                    icon="mdi-close"
                    @click="close"
                    opacity="0.6"
                ></v-icon-btn>
            </v-card-title>
            <v-card-text>
                <slot></slot>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script setup>
import { computed } from 'vue'

const props = defineProps(['modelValue'])
const emit = defineEmits(['update:modelValue'])

const dialog = computed({
    get() {
        return props.modelValue
    },
    set(val) {
        emit('update:modelValue', val)
    },
})

function close() {
    emit('update:modelValue', false)
}
</script>
